export default __webpack_public_path__ + "static/media/step-5.2f8cc776.gif";